import React, { useState } from "react";
import RatingAnalytics from "./RatingAnalytics";
import AnalyticsReport from "./Ratingadvanceinfo";

import "bootstrap/dist/css/bootstrap.min.css";
// import "./RatingAnalyticsTabs.css";

const RatingAnalyticsTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "RatingAnalytics" | "Reports"
  >("RatingAnalytics");

  return (
    <div className="rating-tabs-page">

      <div className="d-flex justify-content-center mb-5 mt-4 gap-3">

        <button
          className={`tab-btn ${
            activeTab === "RatingAnalytics" ? "active" : ""
          }`}
          onClick={() => setActiveTab("RatingAnalytics")}
        >
        Basic Information
        </button>

        <button
          className={`tab-btn ${
            activeTab === "Reports" ? "active" : ""
          }`}
          onClick={() => setActiveTab("Reports")}
        >
          Advance Information
        </button>

      </div>

      {activeTab === "RatingAnalytics" && <RatingAnalytics />}

      {activeTab === "Reports" && <AnalyticsReport />}

    </div>
  );
};

export default RatingAnalyticsTabs;